import { translate } from "@klantondersteuning-zvw/shared";
import { ISimpleForm, PredefinedFieldType } from "@klantondersteuning/shared";

export const GetZorgkostenDeclarerenGemoedsbezwaardenFormulier = (): ISimpleForm => {
  return {
    name: "zorgkosten-declareren-gemoedsbezwaarden-formulier",
    steps: [
      {
        name: translate("Inleiding"),
        isIntroduction: true
      },
      {
        name: translate("GemoedsbezwaardenFormulierStapMijnVerzoek"),
        Sections: [
          {
            name: "stap_mijn_verzoek__mijn_verzoek",
            fields: {
              aantalNotas: {
                type: "number",
                ui: {
                  flexDirection: "column"
                },
                validate: {
                  isRequired: {
                    value: true
                  },
                  greaterThanValue: {
                    value: 0
                  }
                },
                showIsValidCheckmark: true
              },
              totaalbedragDeclaratie: {
                predefinedFieldType: PredefinedFieldType.bedrag,
                isRequired: true,
                icon: "icon icon--currency--euro"
              },
              bijlagenNotasToevoegen: {
                predefinedFieldType: PredefinedFieldType.bijlage,
                maxFileAmount: 20,
                isRequired: true,
                allowedExentions: ["pdf", "jpg", "jpeg", "png"]
              }
            }
          }
        ]
      },
      {
        name: translate("MijnGegevens"),
        Sections: [
          {
            name: "stap_contactgegevens__contactgegevens",
            fields: {
              voorletters: {
                predefinedFieldType: PredefinedFieldType.voorletters,
                isRequired: true
              },
              achternaam: {
                predefinedFieldType: PredefinedFieldType.achternaam,
                isRequired: true,
                autoComplete: true
              },
              geboortedatum: {
                predefinedFieldType: PredefinedFieldType.geboortedatum,
                isRequired: true
              },
              zaaknummer: {
                predefinedFieldType: PredefinedFieldType.text,
                isRequired: true
              },
              email: {
                predefinedFieldType: PredefinedFieldType.email,
                isRequired: true,
                autoComplete: true
              },
              telefoonnummer: {
                predefinedFieldType: PredefinedFieldType.telefoonnummer,
                autoComplete: true
              }
            }
          }
        ]
      }
    ]
  };
};
